import React, {FC} from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
} from "@mui/material";
import {IMotorcycle} from "../../../interfaces/Interfaces";
import {MotorcycleMedia} from "../details/MotorcycleMedia";
import {ButtonsGroupMotoTableCard} from "./ButtonsGroupMotoTableCard";
import {MotorcycleInfo} from "./MotorcycleInfo";
import {Link} from "react-router-dom";

interface ICatalogueGridItem {
    motorcycle: IMotorcycle;
    handleDetailsClick: () => void;
    handleCompareClick: () => void;
    handleToggleFavorite: () => void;
    isInCompareList: boolean;
    isFavourite: boolean;
    compareArrayLength: number;
    navigateToComparePath: string;
    navigateToDetailsPath: string;
    isSmallScreen: boolean;
}

export const CatalogueGridItem: FC<ICatalogueGridItem> = ({
    motorcycle,
    handleDetailsClick,
    handleCompareClick,
    handleToggleFavorite,
    isInCompareList,
    isFavourite,
    compareArrayLength,
    navigateToComparePath,
    navigateToDetailsPath,
    isSmallScreen,
}) => (
    <Card
        sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            boxShadow: 2,
            position: "relative",
            transition: "background-color 0.3s, transform 0.3s",
            backgroundColor: theme => theme.palette.card.background,
            "&:hover": {
                backgroundColor: theme => theme.palette.card.secondary,
                transform: "scale(1.01)",
            },
            "&:hover button": {
                opacity: 1,
                transform: "translateY(0)",
            },
        }}
    >
        <Box
            sx={{
                position: "relative",
                padding: 2,
                height: 180,
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
            component="a"
            href={navigateToDetailsPath}
            onClick={handleDetailsClick}
        >
            <MotorcycleMedia motorcycle={motorcycle}/>
        </Box>
        <CardContent sx={{padding: "10px"}}>
            <Link to={navigateToDetailsPath} style={{textDecoration: "none", color: "inherit"}}>
                <Typography
                    variant="h6"
                    component="div"
                    gutterBottom
                    onClick={handleDetailsClick}
                    sx={{
                        display: "inline-block",
                        cursor: "pointer",
                    }}
                >
                    {motorcycle.makerName} {motorcycle.modelName}
                </Typography>
            </Link>
            <MotorcycleInfo motorcycle={motorcycle}/>
        </CardContent>
        <Box
            sx={{
                position: "absolute",
                top: 10,
                right: 10,
            }}
        >
            <ButtonsGroupMotoTableCard
                handleCompareClick={handleCompareClick}
                handleToggleFavorite={handleToggleFavorite}
                isInCompareList={isInCompareList}
                isFavourite={isFavourite}
                compareArrayLength={compareArrayLength}
                navigateToDetailsPath={navigateToDetailsPath}
                navigateToComparePath={navigateToComparePath}
                mobileMode={isSmallScreen}
            />
        </Box>
    </Card>
);
